class DataFieldUtils {
	getDataFieldName(dataField) {
		if (!dataField) return null;
		if (!dataField.EntityId) return null;
		if (!dataField.FieldName) return null;
		if (!dataField.EntityName) return null;
		return dataField.EntityName + '_' + dataField.FieldName;
	}
}
const dataFieldUtils = new DataFieldUtils();
export default dataFieldUtils;
